module.exports = __webpack_public_path__ + "static/media/scoliosis_severe_left.f35dd53c.png";